import React from 'react';
import { Language } from '@material-ui/icons';

const LanguageIcn = (props) => {
    return (
        <div>
            <Language />
        </div>
    );
};

export default LanguageIcn;
